import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useParams } from 'react-router-dom';
import { H1, Text } from '../components/ui/Typography';
import SafeIcon from '../common/SafeIcon';
import { translations } from '../translations';

const Accordion = ({ title, children }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <div className="border-b border-zinc-200">
      <button 
        onClick={() => setIsOpen(!isOpen)} 
        className="w-full py-6 flex items-center justify-between text-left focus:outline-none"
      >
        <span className="text-lg font-medium text-zinc-900">{title}</span>
        <motion.div 
          animate={{ rotate: isOpen ? 180 : 0 }} 
          className="text-zinc-400"
        >
          <SafeIcon name="ChevronDown" />
        </motion.div>
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div 
            initial={{ height: 0, opacity: 0 }} 
            animate={{ height: 'auto', opacity: 1 }} 
            exit={{ height: 0, opacity: 0 }} 
            className="overflow-hidden"
          >
            <div className="pb-6 text-zinc-600 leading-relaxed">
              {children}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const Faq = () => {
  const { lang = 'nl' } = useParams();
  
  // Dynamic translation binding
  const t = translations[lang]?.faq || translations.nl.faq;

  return (
    <div className="max-w-3xl mx-auto px-6 py-20">
      <H1 className="mb-6 text-center">{t.title}</H1>
      <Text className="text-center mb-16">{t.subtitle}</Text>
      
      <div className="bg-white rounded-3xl p-8 premium-shadow border border-zinc-100">
        {t.items.map((item, i) => (
          <Accordion key={i} title={item.q}>
            {item.a}
          </Accordion>
        ))}
      </div>
    </div>
  );
};

export default Faq;